import { Link } from 'react-router-dom';
import { useTableManagement } from '../../hooks/useTableManagement';
import { TableCard } from '../../components/admin/TableCard';
import { Button } from '../../components/ui/Button';
import './TablesPage.css';

export function TablesPage() {
  const { tables, isLoading, isError, error, deleteTable, isDeleting } = useTableManagement();

  const handleDelete = async (tableId: string) => {
    if (!confirm('Tem certeza que deseja excluir esta mesa?')) {
      return;
    }

    try {
      await deleteTable(tableId);
    } catch (err) {
      alert('Erro ao excluir mesa: ' + (err instanceof Error ? err.message : 'Erro desconhecido'));
    }
  };

  if (isLoading) {
    return (
      <div className="tables-page">
        <div className="tables-page__loading">Carregando mesas...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="tables-page">
        <div className="tables-page__error">
          Erro ao carregar mesas: {error instanceof Error ? error.message : 'Erro desconhecido'}
        </div>
      </div>
    );
  }

  return (
    <div className="tables-page">
      <div className="tables-page__header">
        <div>
          <h1 className="tables-page__title">Gerenciamento de Mesas</h1>
          <p className="tables-page__subtitle">Gerencie as mesas de tênis de mesa do sistema</p>
        </div>
        <Link to="/admin/tables/new">
          <Button>+ Nova Mesa</Button>
        </Link>
      </div>

      {tables.length === 0 ? (
        <div className="tables-page__empty">
          <p>Nenhuma mesa cadastrada ainda.</p>
          <Link to="/admin/tables/new">
            <Button>Cadastrar Primeira Mesa</Button>
          </Link>
        </div>
      ) : (
        <div className="tables-page__grid">
          {tables.map((table) => (
            <TableCard
              key={table.id}
              table={table}
              onDelete={handleDelete}
              isDeleting={isDeleting}
            />
          ))}
        </div>
      )}
    </div>
  );
}
